import PlatesService from '@/application/services/Plates';
import PlateGroupsService from '@/application/services/PlateGroups';
import Util from "@/application/libs/util";
import PlatesProvider from '../../application/providers/PlatesProvider';
import { t } from 'i18next'

const sharedObject = {};

const _getCDFILIAL = () => Util.getFilterInSession().CDFILIAL;
const _getCDSERVFILI = () => Util.getFilterInSession().CDSERVFILI;
const _getIDTIPORESTRICAO = () => Util.getFilterInSession().TPCONTRATO;

let CDPICTPRAT = null;

const _filauxpratFormmaterTurbo = function(o){
    if(o.value === void 0){
        return ""
    } else if(o.value === "P") 
        return "Padrão";
    else
        return "Local"; 
    
}

const focusCell = (grid, fieldName, rowIndex = 0) => {
    grid.gridControl.clearFocusedCell(); // clear current focused cells
    grid.gridControl.ensureColumnVisible(fieldName);
    grid.gridControl.startEditingCell({ rowIndex, colKey: fieldName});
};
const addNewRowToGrid = function (grid, autoFocus = true, singleRow = true, disableSelection = true) {
    grid && grid.addNewRowToGrid(autoFocus, singleRow, disableSelection);
    // implementation moved to grid component
};

const _isEmptyLike = function(a){
    let similarValues = [null, undefined, emptyChar];
    return similarValues.includes(a);
};
const saveParametersGridData = function ({ data, colDef, node, newValue, oldValue}) {
    if(!(_isEmptyLike(newValue) && _isEmptyLike(oldValue))){ // don't trigger save event if both values are empty
        if(_isEmptyLike(newValue)){
            data[colDef.field] = null;
        }
        let CDFILIAL = _getCDFILIAL();
        let NRORG = Util.getLocalVar('userData').NRORG;

        let savePromise;
        if(colDef.field === "NMGRUPOPRATO"){
            savePromise = PlatesService.saveGroupPlates(data, NRORG);
        } else {
            savePromise = PlatesService.saveParametersGridData(data, CDFILIAL, NRORG);
        }
        savePromise
            .then((res) => {
                if(colDef.field !== "NMGRUPOPRATO"){
                    data.PRATO_PARAMETRIZADO = "S";
                    data.IDPREPREPARO = data.IDPREPREPARO_key || data.IDPREPREPARO || "N";
                    data.IDCOMPLEXIDADE = data.IDCOMPLEXIDADE_key || data.IDCOMPLEXIDADE || "BAIXA";
                } else {
                    data.NRITGRUPOPRATOSERV = (res && res.dataset && parseInt(res.dataset.data[0])) || null;
                }
                Util.showSuccessNotification({ title: t('saved_dish_parameter')})
                parametersGridConfiguration.gridControl.refreshCells({rowNodes: [node]}); //force refresh

                let cell = parametersGridConfiguration.gridControl.getFocusedCell();
                if ( cell ) {
                    parametersGridConfiguration.gridControl.setFocusedCell( cell.rowIndex, cell.column );
                }
            })
            .catch((e = {}) => {
                Util.showErrorNotification({ title: t('unable_to_save_dish_parameter'), text: e.error })
            });
    }
};

const onCombinationCellValueChanged = function(eventData) {
    saveCombination(eventData);
};
const saveCombination = function ({ data, colDef }) {
    if(!data.__removed){
        PlatesService.saveCombinationGridData(data, colDef.field, _getCDFILIAL(), _getCDSERVFILI(), _getIDTIPORESTRICAO())
            .then((result) => {
                if (result && result.error) {
                    throw result;
                } else if(result){
                    combinationGridConfiguration.enableSelection();
                    let key = (result.dataset && result.dataset.data[0]) || data.NRCOMBINACAOCARD;
                    key = Number(key).toString();
                    combinationGridConfiguration.reloadData().then(a => {
                        let newElIndex = a.findIndex(ae => ae.NRCOMBINACAOCARD === key);
                        combinationGridConfiguration.gridControl.ensureIndexVisible(newElIndex, "top");

                        let cell = combinationGridConfiguration.gridControl.getFocusedCell();
                        if ( cell ) {
                            combinationGridConfiguration.gridControl.setFocusedCell( cell.rowIndex, cell.column );
                        }
                    });
                    Util.showSuccessNotification({ title: t('saved_combination')})
                }
            })
            .catch((e) => {
                Util.showErrorNotification({ title: t('unable_to_save_combination'), text: e.error })
            });
    }
};
/**
 * @param {String} baseStr 
 * @param {String} maskStr 
 * @param {String} char 
 */
const insertChar = (baseStr, maskStr, char) => {
    if(baseStr === undefined || baseStr === null){
        return baseStr;
    }
    var newStr = "";
    var offset = 0;

    for (var i = 0; i < maskStr.length && i < baseStr.length + offset; i++) {
        if (maskStr[i] === char) {
            newStr += char;
            offset++;
        } else {
            newStr += baseStr[i - offset];
        }
    }
    return newStr;
};

const insertCharComp = (obj, maskStr = CDPICTPRAT, char = '.') => {
    var baseStr = obj.value;
    var newStr = "";
    var offset = 0;

    for (var i = 0; i < maskStr.length && i < baseStr.length + offset; i++) {
        if (maskStr[i] === char) {
            newStr += char;
            offset++;
        } else {
            newStr += baseStr[i - offset];
        }
    }
    return newStr;
};

const savePreparationMethod = function ({ data, colDef }) {
    if(!data.__removed){
        PlatesService.savePreparationMethodGridData(data, colDef.field)
            .then((result) => {
                if (result && !result.error) {
                    prapartionMethodGridConfiguration.enableSelection();
                    let __is_new = !data.NRFORMAPREPARO;
                    if(__is_new){
                        let key = (result.dataset && result.dataset.data[0]) || data.NRFORMAPREPARO;
                        key = Number(key).toString();
                        prapartionMethodGridConfiguration.reloadData().then(a => {
                            let newElIndex = a.findIndex(ae => ae.NRFORMAPREPARO === key);
                            prapartionMethodGridConfiguration.gridControl.ensureIndexVisible(newElIndex, "top");
                        });
                    } else {
                        parametersGridConfiguration.reloadData && parametersGridConfiguration.reloadData();
                    }
                    Util.showSuccessNotification({ title: t('saved_cooking_mode')})
                } else if (result !== null) {
                    throw result;
                }
            })
            .catch((e) => {
                Util.showErrorNotification({ title: t('unable_to_save_brew_mode'), text: e.error })
            });
    }
};
const saveCutType = function ({ data, oldValue, colDef, value }) {
    if (oldValue !== value) {
        PlatesService.saveCutTypeGridData(data, colDef.field)
            .then((result) => {
                if (result && !result.error) {
                    if(data.__is_new_row){
                        cutTypeGridConfiguration.reloadData().then(a => {
                            let key = data.CDAPRERECE.padStart(3, 0);
                            let newElIndex = a.findIndex(ae => ae.CDAPRERECE === key);
                            cutTypeGridConfiguration.gridControl.ensureIndexVisible(newElIndex, "top");
                        });
                    } else {
                        parametersGridConfiguration.reloadData && parametersGridConfiguration.reloadData();
                    }
                    Util.showSuccessNotification({ title: t('saved_cut_type')})
                } else if (result && result.error) {
                    Util.showErrorNotification({ title: t('unable_to_save_cut_type'), text: result.error });
                }
            })
            .catch((e) => {
                Util.showErrorNotification({ title: t('error_saving_cut_type'), text: e.error });
            });
    }
};
const saveMainIngredient = function ({ data, colDef }) {
    if(!data.__removed){
        PlatesService.saveMainIngredientGridData(data, colDef.field)
            .then((result) => {
                mainIngredientGridConfiguration.enableSelection();
                let key = (result.dataset && result.dataset.data[0]) || data.NRINGREDIENTEPRINC;
                key = Number(key).toString();
                if (result && !result.error) {
                    if(!data.NRINGREDIENTEPRINC){ // if is new
                        mainIngredientGridConfiguration.reloadData().then(a => {
                            let newElIndex = a.findIndex(ae => ae.NRINGREDIENTEPRINC === key);
                            mainIngredientGridConfiguration.gridControl.ensureIndexVisible(newElIndex, "top");
                        });
                    } else {
                        parametersGridConfiguration.reloadData && parametersGridConfiguration.reloadData();
                    }
                    Util.showSuccessNotification({ title: t('main_ingredient_saved')})
                } else if (result !== null) {
                    throw result;
                }
            })
            .catch((e) => {
                Util.showErrorNotification({ title: t('unable_to_save_main_ingredient'), text: e.error })
            });
    }
};

const saveTypeProtein = function ({ data, colDef }) {
    const gridData = typeProteinGridConfiguration.getRowData() || [];

    const currentName = data.NMTIPOPROTEINA 
    ? data.NMTIPOPROTEINA.trim().toLowerCase() 
    : '';


    const isDuplicate = gridData.some(row => {
        if (row === data || row.__removed) return false;
        const rowName = row.NMTIPOPROTEINA 
            ? row.NMTIPOPROTEINA.trim().toLowerCase() 
            : '';
        return rowName === currentName;
    });
    

    if (isDuplicate) {
        Util.showErrorNotification({
            title: t('duplicate_type_protein')
        });
        return;
    }
    if(!data.__removed){
        PlatesService.saveTypeProteinGridData(data, colDef.field)
            .then((result) => {
                typeProteinGridConfiguration.enableSelection();
                let key = (result.dataset && result.dataset.data[0]) || data.NRTIPOPROTEINA;
                key = Number(key).toString();
                if (result && !result.error) {
                    if(!data.NRTIPOPROTEINA){ // if is new
                        typeProteinGridConfiguration.reloadData().then(a => {
                            let newElIndex = a.findIndex(ae => ae.NRTIPOPROTEINA === key);
                            typeProteinGridConfiguration.gridControl.ensureIndexVisible(newElIndex, "top");
                        });
                    } else {
                        parametersGridConfiguration.reloadData && parametersGridConfiguration.reloadData();
                    }
                    Util.showSuccessNotification({ title: t('type_protein_saved')})
                } else if (result !== null) {
                    throw result;
                }
            })
            .catch((e) => {
                Util.showErrorNotification({ title: t('unable_to_save_type_protein'), text: e.error })
            });
    }
};

const refreshParametersGridData = function (gridConfiguration) {
    PlatesService.getPlatesParameters().then(data => {
        gridConfiguration.setRowData(data);
    });
};
const saveAttractivenessGridData = function ({ data, colDef }) {
    if(!data.__removed){
        let CDFILIAL = _getCDFILIAL();
        PlatesService.saveAttractivenessGridData(data, CDFILIAL, colDef.field)
            .then((result) => {
                if (result && !result.error) {
                    attractivenessGridConfiguration.enableSelection();
                    if(!data.NRATRATIVIDADEPRATO){ // if is new
                        let key = (result.dataset && result.dataset.data[0]) || data.NRATRATIVIDADEPRATO;
                        key = Number(key).toString();
                        attractivenessGridConfiguration.reloadData().then(a => {
                            let newElIndex = a.findIndex(ae => ae.NRATRATIVIDADEPRATO === key);
                            attractivenessGridConfiguration.gridControl.ensureIndexVisible(newElIndex, "top");
                        });
                    } else {
                        parametersGridConfiguration.reloadData && parametersGridConfiguration.reloadData();
                    }
                    Util.showSuccessNotification({ title: t('saved_attractiveness')})
                } else if (result !== null) {
                    throw result;
                }
            })
            .catch((e) => {
                Util.showErrorNotification({ title: t('unable_to_save_attractiveness'), text: e.error })
            });
    }
};

const shouldEditCombinationGrid = (e) => {
    return (e.colDef.field === "PERCENTREDUCAO" && e.data.IDCOMBINACAO !== "RESTRICAO") || e.data.__is_new_row;
}

const _getFormattedConsumptionHistoryRowData = ({data}) => {
    let rowData = consumptionHistoryGridConfiguration.getRowData();
    rowData = rowData.sort((a, b) => a.CDPRATO - b.CDPRATO);
    const duplicateIndex = rowData.findIndex(d => 
        d.CDPRATO === data.CDPRATO && 
        d.CDFILAUXPRAT === data.CDFILAUXPRAT && 
        d.MANUTENCAO === 'N'
    );
    duplicateIndex !== -1 && rowData.splice(duplicateIndex, 1); 
    return rowData;
};

const onConsumptionHistoryCellChanged = ({data, node, colDef}) => {
    PlatesService.saveConsumptionHistoryData({...data}, colDef.field).then((r) => {
        if(r && r.error){
            throw r;
        } else if (r !== null){
            const newId = r.dataset && r.dataset.data && r.dataset.data[0];
            const __is_new_row = data.__is_new_row;
            if(newId){
                data.NRHISTCONSUMOPRATO = parseInt(newId);
                data.MANUTENCAO = 'S';
                delete data.__is_new_row;
                sharedObject.onConsumptionHistoryCheckedRowsChange(true);
                const rowData = _getFormattedConsumptionHistoryRowData({data});
                consumptionHistoryGridConfiguration.setRowData(rowData, {setIsAddingNewRow: false});
                if(__is_new_row){ // redraw and flash
                    const selfIndex = rowData.indexOf(data);
                    consumptionHistoryGridConfiguration.gridControl.ensureIndexVisible(selfIndex);
                    const rowNode = consumptionHistoryGridConfiguration.gridControl.rowModel.rowsToDisplay[selfIndex];
                    consumptionHistoryGridConfiguration.gridControl.flashCells({rowNodes: [rowNode]});
                }
            } else {
                consumptionHistoryGridConfiguration.updateRowNode({data, node, setIsAddingNewRow: false});
            }
        }
    }).catch(e => {
        Util.showErrorNotification({ title: t('error_saving_consumption_percentage_history'), text: e.error });
    });
};

const SNmap = { "S": "Sim", "N": "Não"};

const filauxpratFormmater = ({ value }) => {
    let returnValue = "";
    if (value) {
        returnValue = value === 'P' ? "Padrão" : "Local";
    }
    return returnValue;
}

//TODO: refactor
const _addEmptyOption = (func, emptyOption) => {
    return (v) => {
        return new Promise((resolve) => {
            func(v).then((res) => {
                resolve([emptyOption].
                        concat(res))
            })
        });
    }
};

const emptyChar = String.fromCharCode(0x00A0);
const defaultColDef = {
    resizable: true,
    filter: true,
    sortable: true
};

const parametersGridConfiguration = {
    defaultColDef,
    columnDefs: [
        {
            headerName: "", field: "checkboxColumn",
            width: 35, checkboxSelection: true, hide: true, 
            editable: false, resizable: false, sortable: false,
            pinned: 'left', lockPinned: true, headerCheckboxSelection: true,
            headerCheckboxSelectionFilteredOnly: true
        },
        {   
            headerValueGetter: ()=> {return t('tree') } , field: "CDFILAUXPRAT", checkboxSelection: false, valueFormatter: _filauxpratFormmaterTurbo, sortable: true, 
            filter: "agTextColumnFilter"
        },
        {
            headerValueGetter: ()=> {return t('code') } , field: "CDPRATO", checkboxSelection: false, filter: "agTextColumnFilter",
            filterParams: {
                defaultOption: 'startsWith',
                textFormatter: (value) => {
                    if (value.includes(".")) {// breaks if the initial string already has the char
                        return value;
                    } else {
                        return insertChar(value, CDPICTPRAT, ".");
                    }
                }
            },
            maxWidth: 105,
            valueFormatter: insertCharComp,
        },
        {
            headerValueGetter: ()=> {return t('name') } , field: "NMPRATO", checkboxSelection: false, filter: "agTextColumnFilter",
            onCellClicked: (data) => openModalRecipe(data),
        },
        {
            headerValueGetter: ()=> {return t('groupings') }  , field: "NMAGRUPGRPRAT", checkboxSelection: false, filter: "agTextColumnFilter",
        },
        {
            headerValueGetter: ()=> {return t('group_of_dishes') } , field: "NMGRUPOPRATO", checkboxSelection: false, filter: "agTextColumnFilter",
            editable: true, cellEditor: "vSelectCellEditor",
            cellEditorParams: {
                optionsSearchFunction: _addEmptyOption(PlatesService.getGroupPlates, {NRGRUPOPRATOSERV: null, NMGRUPOPRATO: emptyChar}),
                valueColumn: "NRGRUPOPRATOSERV",
                labelColumn: "NMGRUPOPRATO",
            },
        },
        {
            headerValueGetter: ()=> {return t('complexity') } , field: "IDCOMPLEXIDADE", editable: true, cellEditor: "optionsBunchCellEditor",
            cellEditorParams: ()=>Util.translateOptionsBunchCellEditor({
                options: {
                    "ALTA": "ALTA", "MEDIA": "MEDIA", "BAIXA": "BAIXA"
                }
            }), 
            valueFormatter: ({ value }) => t(value)
        },
        {
            headerValueGetter: ()=> {return t('preparation_pre') } , field: "IDPREPREPARO", editable: true, cellEditor: "optionsBunchCellEditor",
            cellEditorParams: ()=>Util.translateOptionsBunchCellEditor({options: SNmap}), 
            valueFormatter: ({ value }) => t(SNmap[value]),
            width: 88,
        },
        {
            headerValueGetter: ()=> {return t('color') } , field: "IDCOR", editable: true, cellEditor: "vSelectCellEditor",
            cellEditorParams:()=>Util.translateVSelectCellEditor({
                options: [
                    { value: null, label: emptyChar },
                    { value: "NA", label: "NA" },
                    { value: "VERMELHO", label: "VERMELHO" },
                    { value: "AMARELO", label: "AMARELO" },
                    { value: "BRANCO", label: "BRANCO" },
                    { value: "VERDE", label: "VERDE" },
                    { value: "ROXO", label: "ROXO" },
                    { value: "BEGE", label: "BEGE" },
                    { value: "COLORIDA(O)", label: "COLORIDA(O)" },
                    { value: "MARROM", label: "MARROM" },
                    { value: "LARANJA", label: "LARANJA" },
                    { value: "DOURADO", label: "DOURADO" },
                    { value: "ROSA", label: "ROSA" },
                    { value: "CASTANHO CLARO", label: "CASTANHO CLARO" },
                    { value: "PRETO", label: "PRETO" },
                    { value: "VERDE CLARO", label: "VERDE CLARO" },
                    { value: "ROSA CLARO", label: "ROSA CLARO" },
                    { value: "CARAMELO", label: "CARAMELO" },
                    { value: "AMARELO CLARO", label: "AMARELO CLARO" },
                    { value: "VERDE ESCURO", label: "VERDE ESCURO" },
                    { value: "CORAL", label: "CORAL" },
                    { value: "SALMAO", label: "SALMAO" },
                    { value: "AMARELO ESCURO", label: "AMARELO ESCURO" },
                    { value: "COBRE", label: "COBRE" },
                    { value: "VERMELHO ESCURO", label: "VERMELHO ESCURO" },
                    { value: "VERMELHO ENEGRECIDO", label: "VERMELHO ENEGRECIDO" },
                    { value: "ROSA ESCURO", label: "ROSA ESCURO" },
                    { value: "FERRUGEM", label: "FERRUGEM" },
                    { value: "LILAS", label: "LILAS" },
                    { value: "AZUL", label: "AZUL" },
                    { value: "PARDO", label: "PARDO" },
                ],
                valueField: "IDCOR"
            }),
            valueFormatter: ({ value }) => t(value)
        },
        {
            headerValueGetter: ()=> {return t('ing_main_1') } , field: "NMINGREDIENTEPRINC1", editable: true, cellEditor: "vSelectCellEditor",
            cellEditorParams: {
                // optionsSearchFunction: (v) => PlatesService.getMainIngredient(v, true),
                optionsSearchFunction: _addEmptyOption(PlatesService.getMainIngredient, {NRINGREDIENTEPRINC: null, NMINGREDIENTEPRINC: emptyChar}),
                remoteFilter: false,
                valueColumn: "NRINGREDIENTEPRINC",
                labelColumn: "NMINGREDIENTEPRINC",
            },
        },
        {
            headerValueGetter: ()=> {return t('ing_main_2') } , field: "NMINGREDIENTEPRINC2", editable: true, cellEditor: "vSelectCellEditor",
            cellEditorParams: {
                optionsSearchFunction: _addEmptyOption(PlatesService.getMainIngredient, {NRINGREDIENTEPRINC: null, NMINGREDIENTEPRINC: emptyChar}),
                remoteFilter: false,
                valueColumn: "NRINGREDIENTEPRINC",
                labelColumn: "NMINGREDIENTEPRINC",
            },
        },
        {
            headerValueGetter: ()=> {return t('type_of_cut') } , field: "TIPOCORTE", editable: true, cellEditor: "vSelectCellEditor",
            cellEditorParams: {
                optionsSearchFunction: _addEmptyOption(PlatesService.getCutType, {CDAPRERECE: null, TIPOCORTE: emptyChar}),
                remoteFilter: false,
                valueColumn: "CDAPRERECE",
                labelColumn: "TIPOCORTE"
            },
        },
        {
            headerValueGetter: ()=> {return t('mode_preparation') }  , field: "NMFORMAPREPARO", editable: true, cellEditor: "vSelectCellEditor",
            cellEditorParams: {
                optionsSearchFunction: _addEmptyOption(PlatesService.getPreparationMethod, {NRFORMAPREPARO: null, NMFORMAPREPARO: emptyChar}),
                remoteFilter: false,
                valueColumn: "NRFORMAPREPARO",
                labelColumn: "NMFORMAPREPARO",
            },
        },
        {
            headerValueGetter: ()=> {return t('attractiveness') } , field: "NMATRATIVIDADEPRATO", editable: true, cellEditor: "vSelectCellEditor",
            cellEditorParams: {
                optionsSearchFunction: _addEmptyOption(PlatesService.getAttractiveness, {NRATRATIVIDADEPRATO: null, NMATRATIVIDADEPRATO: emptyChar}),
                remoteFilter: false,
                valueColumn: "NRATRATIVIDADEPRATO",
                labelColumn: "NMATRATIVIDADEPRATO"
            },
        },
        {
            headerValueGetter: ()=> {return t('type_protein') } , field: "NMTIPOPROTEINA", editable: true, cellEditor: "vSelectCellEditor",
            cellEditorParams: {
                optionsSearchFunction: _addEmptyOption(PlatesService.getProteinType, {NRTIPOPROTEINA: null, NMTIPOPROTEINA: emptyChar}),
                remoteFilter: false,
                valueColumn: "NRTIPOPROTEINA",
                labelColumn: "NMTIPOPROTEINA"
            },
        }
    ],
    dataSource: PlatesService.getPlatesParameters,
    onCellValueChanged: saveParametersGridData,
    rowSelection: "single"
};

const openModalRecipe = function (params){
    PlateGroupsService.getPlateRecipe(params.data).then(data=>{
        plateRecipeGrid.__data = data;
        
        plateServiceInstance.vueContext.$modal.show('plates-recipe-modal', {}, {
            height:'auto',
            clickToClose: true
        });
    });

};

const plateRecipeGrid = {
    columnDefs:[
        {
            headerValueGetter: ()=> {return t('code') } , field: "CDARVPROD", checkboxSelection: false, filter: "agTextColumnFilter",
            lockVisible: true, resizable: true, sortable: true, maxWidth: 150, 
            valueFormatter: ({ value }) => insertChar(value, CDPICTPRAT, ".")
        },
        {
            headerValueGetter: ()=> {return t('product') } , field: "NMPRODUTO", checkboxSelection: false, filter: "agTextColumnFilter",
            lockVisible: true, resizable: true, sortable: true, maxWidth: 500
        },
        {
            headerValueGetter: ()=> {return t('amount') } , field: "QTPRODUTO", checkboxSelection: false, filter: "agTextColumnFilter",
            lockVisible: true, editable: true, resizable: true, sortable: true, maxWidth: 149, valueFormatter: currencyValueFormatter
        },
        {
            headerValueGetter: ()=> {return t('unit') } , field: "SGUNIDADE", checkboxSelection: false, filter: "agTextColumnFilter",
            lockVisible: true,  resizable: true, sortable: true, maxWidth: 149
        }
    ],
    onCellValueChanged: (params) => {
        let value = params.data.QTPRODUTO;
        
        if (typeof value === "string") {
            value = value.replace(",", "."); 
            value = parseFloat(value);
        }
        params.data.QTPRODUTO = value;
        params.node.setDataValue(params.column.colId, value);
        updatePlateRecipe(params);
    }
};

const updatePlateRecipe = ({data}) => {
    PlateGroupsService.updatePlateRecipe(data).then((result) => {
        if(result && result.error){
            throw result;
        }else if(result){
            Util.showSuccessNotification({ title: t("plate_recipe_saved")});
        }
    }).catch((e = {}) => {
        Util.showErrorNotification({ title: t("unable_to_save_plate_recipe"), text: e.error });
    });
};

const currencyValueFormatter = ({ value }) => {
    return value && !Number.isNaN(value) ? Number(value) : '';
};

const attractivenessGridConfiguration = {
    defaultColDef,
    columnDefs: [
        { headerValueGetter: ()=> {return t('name') } , field: "NMATRATIVIDADEPRATO", checkboxSelection: true, editable: true },
        { headerValueGetter: ()=> {return t('weight') } , field: "VRPESOATRATIVIDADE", checkboxSelection: false, editable: true }
    ],
    dataSource: PlatesService.getAttractivenessGridData,
    onCellValueChanged: saveAttractivenessGridData,
    editType: 'fullRow',
};

const deleteCheckedRows = function (grid, deleterFunction) {
    let advancedOptions = grid.advancedOptions;
    let selectedRows = advancedOptions.api.getSelectedRows();
    let rowData = grid.getRowData();
    if (selectedRows.length > 0) {
        return deleterFunction(selectedRows).then(() => {
            let newRowData = rowData.filter(r => !selectedRows.includes(r));
            grid.setRowData(newRowData);
        });
    } else {
        return Promise.reject({ error: t('no_record_selected') });
    }
};

const prapartionMethodGridConfiguration = {
    defaultColDef,
    columnDefs: [
        { headerValueGetter: ()=> {return t('name') } , field: "NMFORMAPREPARO", checkboxSelection: true, editable: true, lockVisible: true }
    ],
    dataSource: PlatesService.getPreparationMethod,
    onCellValueChanged: savePreparationMethod,
    editType: 'fullRow',
};

const cutTypeGridConfiguration = {
    defaultColDef,
    columnDefs: [
        { headerValueGetter: ()=> {return t('code') } , field: "CDAPRERECE", checkboxSelection: true, 
            editable: (e) => e.data.__is_new_row, lockVisible: true },
        { headerValueGetter: ()=> {return t('name') } , field: "TIPOCORTE", checkboxSelection: false, editable: true, lockVisible: true }
    ],
    dataSource: PlatesService.getCutType,
    onCellValueChanged: saveCutType,
    editType: 'fullRow',
};

const mainIngredientGridConfiguration = {
    defaultColDef,
    columnDefs: [
        { headerValueGetter: ()=> {return t('name') } , field: "NMINGREDIENTEPRINC", checkboxSelection: true, editable: true, lockVisible: true }
    ],
    dataSource: PlatesService.getMainIngredient,
    onCellValueChanged: saveMainIngredient,
    editType: 'fullRow',
};

const typeProteinGridConfiguration = {
    defaultColDef,
    columnDefs: [
        { headerValueGetter: ()=> {return t('name') } , field: "NMTIPOPROTEINA", checkboxSelection: true, editable: true, lockVisible: true }
    ],
    dataSource: PlatesService.getProteinType,
    onCellValueChanged: saveTypeProtein,
    editType: 'fullRow',
};

const __debouncedOnCombinationCellValueChanged = Util.debounce(onCombinationCellValueChanged, 200).bind(this);

const combinationGridConfiguration = {
    defaultColDef: {
        resizable: true, 
        lockVisible: true, 
        checkboxSelection: false,
        editable: false,
        sortable: true,
        filter: true
    },
    columnDefs: [
        {
            headerValueGetter: ()=> {return t('code') } , field: "CDGRTIPOPR",
            checkboxSelection: true, lockVisible: true, headerCheckboxSelection: true, headerCheckboxSelectionFilteredOnly: true, 
            filter: "agTextColumnFilter", filterParams: { defaultOption: 'startsWith'}
        },
        {
            headerValueGetter: ()=> {return t('group_tp_dish') } , field: "NMGRTIPOPR", 
            editable: shouldEditCombinationGrid, lockVisible: true
        },
        {
            headerValueGetter: ()=> {return t('type') } , field: "TIPO"
        },
        {
            headerValueGetter: ()=> {return t('code') } , field: "CODIGO"
        },
        {
            headerValueGetter: ()=> {return t('name') } , field: "NOME"
        },
        {
            headerValueGetter: ()=> {return t('code') } , field: "CDGRTIPOPR_COMB",
            filter: "agTextColumnFilter", filterParams: { defaultOption: 'startsWith'}
        },
        {
            headerValueGetter: ()=> {return t('group_tp_dish') } , field: "NMGRTIPOPR_COMB", 
            editable: shouldEditCombinationGrid, lockVisible: true
        },
        {
            headerValueGetter: ()=> {return t('type') } , field: "TIPO_COMB"
        },
        {
            headerValueGetter: ()=> {return t('code') } , field: "CODIGO_COMB"
        },
        {
            headerValueGetter: ()=> {return t('name') } , field: "NOME_COMB"
        },
        {
            headerValueGetter: ()=> {return t('comb_type') } , field: "IDCOMBINACAO", resizable: true,
            editable: shouldEditCombinationGrid, lockVisible: true, cellEditor: "optionsBunchCellEditor",
            cellEditorParams: ()=>Util.translateOptionsBunchCellEditor({
                options: {
                    "RESTRICAO": t('RESTRICAO'), "OBRIGATORIO": t('OBRIGATORIO')
                }
            }),
            valueFormatter: ({ value }) => t(value)
        },
        {
            headerValueGetter: ()=> {return t('percentage_Consumption_Reduction') } , field: "PERCENTREDUCAO", resizable: true,
            editable: shouldEditCombinationGrid, lockVisible: true
        }
    ],
    dataSource: PlatesService.getCombinations,
    resizeStyle: 'auto',
    onCellValueChanged: __debouncedOnCombinationCellValueChanged,
};

const _getFirstNonEmpty = (...vals) => {
    for (var i = 0;i < vals.length; i++) {
        const element = vals[i];
        if(element){
            return element;
        }
    }
};

const _decodeCombinationType = (combinationRow) => {
    const propsToType = {NMPRATO: 'Prato', NMGRUPOPRATO: 'Grupo', NMTIPOPRAT: 'Coluna'};
    // key should be a truthy value and it needs to be mapped in propsToType
    const keyObject = Object.keys(combinationRow).find(e => combinationRow[e] && propsToType[e]);
    return propsToType[keyObject];
};

const getGridRowFromCombinationForm = (formData) => {
    Object.keys(formData).forEach(p => formData[p] === null && (formData[p] = {}));
    
    const {
        NRCOMBINACAOCARD,
        combinationSelectedplateGroupType,              
        combinationSelectedPlateGroup, 
        combinationSelectedPlateType, 
        combinationSelectedPlate,
        selectedPlateGroupType,
        selectedPlateGroup,
        selectedPlate,
        IDCOMBINACAO,
        PERCENTREDUCAO
    } = formData;

    const TIPO = _decodeCombinationType({...selectedPlate, ...selectedPlateGroup});
    const TIPO_COMB = _decodeCombinationType({...combinationSelectedPlate, 
        ...combinationSelectedPlateGroup,
        ...combinationSelectedPlateType});

    const newRow = {
        NRCOMBINACAOCARD,
        CDGRTIPOPR: selectedPlateGroupType.CDGRTIPOPR,
        NMGRTIPOPR: selectedPlateGroupType.NMGRTIPOPR,
        CDGRTIPOPR_COMB: combinationSelectedplateGroupType.CDGRTIPOPR,
        NMGRTIPOPR_COMB: combinationSelectedplateGroupType.NMGRTIPOPR,
        PERCENTREDUCAO: PERCENTREDUCAO,
        IDCOMBINACAO,

        CODIGO: _getFirstNonEmpty(selectedPlate.CDPRATO, selectedPlateGroup.NRGRUPOPRATOSERV),
        NOME: _getFirstNonEmpty(selectedPlate.NMPRATO, selectedPlateGroup.NMGRUPOPRATO),
        TIPO,

        CODIGO_COMB: _getFirstNonEmpty(combinationSelectedPlate.CDPRATO, 
                                        combinationSelectedPlateGroup.NRGRUPOPRATOSERV,
                                        combinationSelectedPlateType.CDTIPOPRAT),
        NOME_COMB: _getFirstNonEmpty(combinationSelectedPlate.NMPRATO, 
                                        combinationSelectedPlateGroup.NMGRUPOPRATO,
                                        combinationSelectedPlateType.NMTIPOPRAT),
        TIPO_COMB,
    };

    newRow.CODIGO = `${TIPO==='Prato' && 'P - ' || ''}${newRow.CODIGO}`;
    newRow.CODIGO_COMB = `${TIPO_COMB==='Prato' && 'P - ' || ''}${newRow.CODIGO_COMB}`;

    return newRow;
};

const insertNewCombinationRow = (formData) => {
    const gridRow = getGridRowFromCombinationForm(formData);
    let gridData = combinationGridConfiguration.getRowData();
    gridData.push(gridRow);
    gridData = Util.sortBy(gridData, ['IDCOMBINACAO', 'CDGRTIPOPR', 'TIPO', 'CODIGO', 'CDGRTIPOPR', 'TIPO_COMB', 'CODIGO_COMB']);
    combinationGridConfiguration.setRowData(gridData);  
    const index = gridData.findIndex(i => i.NRCOMBINACAOCARD === formData.NRCOMBINACAOCARD);
    combinationGridConfiguration.gridControl.ensureIndexVisible(index, "top");
    const rowNode = combinationGridConfiguration.gridControl.rowModel.rowsToDisplay[index];
    combinationGridConfiguration.gridControl.flashCells({rowNodes: [rowNode]});
};

const reloadCombination = () => {
    combinationGridConfiguration.reloadData();
};

const reloadAttractiveness = () => {
    attractivenessGridConfiguration.reloadData();
};

const _getSelectedParameterPlate = () => {
    let selectedRow = parametersGridConfiguration.advancedOptions.api.getSelectedRows();
    return selectedRow.length && selectedRow[0] || {};
};

const onPlateTypeRestrictionRuleCellValueChenged = ({data}) => {
    if(data.CDTIPOPRAT){
        PlatesService.insertPlateTypeRestrictionRule(data.CDTIPOPRAT, sharedObject.selectedRestrictionRule).then((newKey) => {
            const rowData = restrictionRulesPlateTypeGridConfig.getRowData();
            data.NRRESTRICAOTPPRAT = parseInt(newKey);
            data.NRREGRARESTREPET = sharedObject.selectedRestrictionRule;
            delete data.__is_new_row;
            const sortedRowData = Util.sortBy(rowData, ['CDTIPOPRAT']);
            restrictionRulesPlateTypeGridConfig.setRowData(sortedRowData, {setIsAddingNewRow: false});
            restrictionRulesPlateTypeGridConfig.enableSelection();
        }).catch((e = {}) => {
            Util.showErrorNotification({ title: t('error_saving_dish_type_for_repeat_restriction_rule'), text: e.error });
        });
    } else {
        Util.showErrorNotification({ title: t('error_saving_dish_type_for_repeat_restriction_rule'),
            text: t('field_type_of_dish_is_required')
        });
    }
};

const defaultIngredientSaveErrorHandler = (e = {}) => {
    Util.showErrorNotification({ title: t('error_saving_ingredient_to_restriction_restriction_rule'), text: e.error });
};

const onIngredientRestrictionRuleCellValueChenged = ({data}) => {
    // if(data.NRINGREDIENTEPRINC){
        PlatesService.saveIngredientRestrictionRule(data, sharedObject.selectedRestrictionRule).then((newKey) => {
            if(data.__is_new_row){
                const rowData = restrictionRulesIngredientGridConfig.getRowData();
                data.NRRESTRICAOINGRED = parseInt(newKey);
                data.NRREGRARESTREPET = sharedObject.selectedRestrictionRule;
                data.NMINGREDIENTEPRINC = data.NMINGREDIENTEPRINC || 'TODOS';
                data.IDINGREDIENTE1 = data.IDINGREDIENTE1 || 'S';
                data.IDINGREDIENTE2 = data.IDINGREDIENTE2 || 'S';
                data.IDDIASEGUIDO = data.IDDIASEGUIDO || 'S';
                delete data.__is_new_row;
                const sortedRowData = Util.sortBy(rowData, ['NRINGREDIENTEPRINC']);
                restrictionRulesIngredientGridConfig.setRowData(sortedRowData, {setIsAddingNewRow: false});
                restrictionRulesIngredientGridConfig.enableSelection();
            }

            Util.showSuccessNotification({ title: t('ingredient_for_repetition_restriction_rule_successfully_saved')});
        }).catch(defaultIngredientSaveErrorHandler);
    // } else {
    //     Util.showErrorNotification({ title: "Erro ao salvar Ingrediente para Regra de Restrição de Repetição.",
    //         text: "O campo Ingrediente é obrigatório"
    //     });
    // }
};

const replicateParametersGridConfiguration = {
    defaultColDef: {
      resizable: true,
      lockVisible: true,
      editable: false,
      sortable: true,
      filter: true,
    },
    columnDefs: [
      {
        headerValueGetter: () => t('tree'),
        field: "CDFILAUXPRAT",
        maxWidth: 100,
        checkboxSelection: true,
        headerCheckboxSelection: true,
        headerCheckboxSelectionFilteredOnly: true,
        valueFormatter: _filauxpratFormmaterTurbo
      },
      {
        headerValueGetter: () => t('unit'),
        field: "CDFILIAL",
        maxWidth: 100,
        valueFormatter: ({ value }) => value === 'P' ? 'Padrão' : value
      },
      {
        headerValueGetter: () => t('code'),
        field: "CDPRATO",
        maxWidth: 100,
        valueFormatter: ({ value }) => SNmap[value]
      },
      {
        headerValueGetter: () => t('name'),
        field: "NMPRATO",
        minWidth: 463,

      },
    ],
    rowData: [],

    // permite múltiplas seleções
    rowSelection: "multiple",
    suppressRowClickSelection: true,
    // este handler vai ‘togglear’ a seleção sem limpar as outras
    onRowClicked: params => {
      const alreadySelected = params.node.isSelected();
      params.node.setSelected(!alreadySelected, /* clearSelection = */ false);
    },
    onSelectionChanged: (params) => updateReplicateSelectedCount(params),
    onGridReady: (params) => updateReplicateSelectedCount(params),
  };

const importPlatesGridConfiguration = {
    defaultColDef: {
        resizable: true, 
        lockVisible: true, 
        checkboxSelection: false, 
        editable: false,
        sortable: true,
        filter: true
    },
    columnDefs: [
        {
            headerValueGetter: ()=> {return t('complexity') } , field: "IDCOMPLEXIDADE"
        },
        {
            headerValueGetter: ()=> {return t('preparation_pre') } , field: "IDPREPREPARO",
            maxWidth: 88,
            valueFormatter: ({ value }) => SNmap[value]
        },
        {
            headerValueGetter: ()=> {return t('color') } , field: "IDCOR"
        },
        {
            headerValueGetter: ()=> {return t('ing_main_1') } , field: "NMINGREDIENTEPRINC1"
        },
        {
            headerValueGetter: ()=> {return t('ing_main_2') } , field: "NMINGREDIENTEPRINC2"
        },
        {
            headerValueGetter: ()=> {return t('type_of_cut') } , field: "NMAPRERECE"
        },
        {
            headerValueGetter: ()=> {return t('mode_preparation') } , field: "NMFORMAPREPARO"
        },
        {
            headerValueGetter: ()=> {return t('type_protein') } , field: "NMTIPOPROTEINA"
        }
    ],
    dataSource: () => PlatesService.getSimilarPlates(_getSelectedParameterPlate()),
    rowSelection: "single"
};



const consumptionHistoryGridConfiguration = {
    defaultColDef: {
        resizable: true, 
        lockVisible: true, 
        checkboxSelection: false, 
        editable: false,
        sortable: true,
        filter: true
    },
    columnDefs: [
        {
            headerName: "", field: "checkboxColumn",
            width: 35, checkboxSelection: true, hide: true, 
            editable: false, resizable: false, sortable: false,
            pinned: 'left', lockPinned: true, headerCheckboxSelection: true,
            headerCheckboxSelectionFilteredOnly: true
        },
        {   
            headerValueGetter: ()=> {return t('tree') } , field: "CDFILAUXPRAT", checkboxSelection: false, valueFormatter: _filauxpratFormmaterTurbo, sortable: true, 
            filter: "agTextColumnFilter"
        },
        {
            headerValueGetter: ()=> {return t('code') } , field: "CDPRATO", 
            onCellDoubleClicked: ({rowIndex}) => focusCell(consumptionHistoryGridConfiguration, "NMPRATO", rowIndex),
        },
        {
            headerValueGetter: ()=> {return t('name') } , field: "NMPRATO",
            editable: ({data}) => !data.NRHISTCONSUMOPRATO && data.__is_new_row,
            cellEditor: "vSelectCellEditor",
            cellClass: ["select-350"],
            cellEditorParams: {
                optionsSearchFunction: PlatesService.getPlatesConsumptionHistory,
                valueColumn: "CDPRATO",
                labelColumn: "NMPRATO",
                outDataColumns: ["CDPRATO", "CDFILAUXPRAT"],
                searchableColumns: ["CDPRATO" , "NMPRATO"]
            },
        },
        {
            headerValueGetter: ()=> {return t('percentage_Consumption') } , field: "VRPECONSCARD",
            editable: true
        },
        {
            headerValueGetter: ()=> {return t('maintenance') } , field: "MANUTENCAO",
            valueFormatter: ({ value }) => SNmap[value]
        }
    ],
    dataSource: () => PlatesService.getConsumptionHistory("S"),
    rowSelection: "single",
    onCellValueChanged: onConsumptionHistoryCellChanged
};
const changeConsumptionHistoryDataSource = function(type) {
    consumptionHistoryGridConfiguration.dataSource = () => PlatesService.getConsumptionHistory(type);
};

const restrictionRulesPlateTypeGridConfig = {
    defaultColDef: {
        resizable: true, 
        lockVisible: true, 
        checkboxSelection: false, 
        editable: false,
        sortable: true,
        filter: true
    },
    columnDefs: [
        {
            headerValueGetter: ()=> {return t('code') } , field: "CDTIPOPRAT",
            onCellDoubleClicked: ({rowIndex}) => focusCell(restrictionRulesPlateTypeGridConfig, "NMTIPOPRAT", rowIndex),
        },
        {
            headerValueGetter: ()=> {return t('name') } , field: "NMTIPOPRAT",
            editable: ({data}) => data.__is_new_row,
            cellEditor: "vSelectCellEditor",
            cellClass: ["select-350"],
            cellEditorParams: {
                optionsSearchFunction: PlatesService.getPlateTypeNotInRestrictionRule,
                valueColumn: "CDTIPOPRAT",
                labelColumn: "NMTIPOPRAT",
                outDataColumns: ["CDTIPOPRAT", "CDTIPOPRAT"],
                searchableColumns: ["CDTIPOPRAT" , "NMTIPOPRAT"]
            },
        },
    ],
    dataSource: () => PlatesService.getPlateTypeByRestrictionRule(sharedObject.selectedRestrictionRule),
    onCellValueChanged: onPlateTypeRestrictionRuleCellValueChenged
};

const restrictionRulesIngredientOptionsMap = {
    S: t('do_not_repeat'),
    N: t('repeat')
};

const repeatedDaysOptionsMap = {
    S: t('consider'),
    N: t('not_consider')
};

const restrictionRulesIngredientGridConfig = {
    defaultColDef: {
        resizable: true, 
        lockVisible: true, 
        checkboxSelection: false, 
        editable: false,
        sortable: true,
        filter: true
    },
    columnDefs: [
        {
            headerValueGetter: ()=> {return t('ingredient') } , field: "NMINGREDIENTEPRINC",
            editable: ({data}) => data.__is_new_row,
            cellEditor: "vSelectCellEditor",
            cellClass: ["select-350"],
            cellEditorParams: {
                optionsSearchFunction: (query) => PlatesService.getIngredientsNotInRestrictionRule(query, sharedObject.selectedRestrictionRule),
                valueColumn: "NRINGREDIENTEPRINC",
                labelColumn: "NMINGREDIENTEPRINC",
                outDataColumns: ["NRINGREDIENTEPRINC", "NRINGREDIENTEPRINC"],
                searchableColumns: ["NRINGREDIENTEPRINC" , "NMINGREDIENTEPRINC"]
            },
        },
        {
            headerValueGetter: ()=> {return t('ingredient_1') } , field: "IDINGREDIENTE1",
            editable: true,
            cellEditor: "optionsBunchCellEditor",
            // cellClass: ["permission-controll-check-editor"],
            // cellRenderer: IDAtivoCellRenderer,
            valueFormatter: ({ value }) => restrictionRulesIngredientOptionsMap[value],
            // onCellDoubleClicked: flipValue,
            // onCellClicked: flipValue,
            // cellStyle: hasLoadingProp,
            cellEditorParams: {
                options: restrictionRulesIngredientOptionsMap
            },
            filter: false,
        },
        {
            headerValueGetter: ()=> {return t('ingredient_2') } , field: "IDINGREDIENTE2",
            editable: true,
            cellEditor: "optionsBunchCellEditor",
            // cellClass: ["permission-controll-check-editor"],
            // cellRenderer: IDAtivoCellRenderer,
            valueFormatter: ({ value }) => restrictionRulesIngredientOptionsMap[value],
            // onCellDoubleClicked: flipValue,
            // onCellClicked: flipValue,
            // cellStyle: hasLoadingProp,
            cellEditorParams: {
                options: restrictionRulesIngredientOptionsMap
            },
            filter: false,
        },
        {
            headerValueGetter: ()=> {return t('consecutive_days') } , field: "IDDIASEGUIDO",
            editable: true,
            cellEditor: "optionsBunchCellEditor",
            valueFormatter: ({ value }) => repeatedDaysOptionsMap[value],
            cellEditorParams: {
                options: repeatedDaysOptionsMap
            },
            filter: false,
        }
    ],
    dataSource: () => PlatesService.getIngredientsRestrictionRule(sharedObject.selectedRestrictionRule),
    onCellValueChanged: onIngredientRestrictionRuleCellValueChenged
};

const mainIngretientsList = async () => {
    const list = await PlatesService.getMainIngredient();
    return list;
};

const updateReplicateSelectedCount = (apiOrParams) => {
    const api = apiOrParams && apiOrParams.api ? apiOrParams.api : null;
    const selectedCount = (api && api.getSelectedRows && api.getSelectedRows().length) || 0;
    const viewContext = plateServiceInstance && plateServiceInstance.vueContext;

    if(viewContext && viewContext.view && viewContext.view.parametersPanel && viewContext.view.parametersPanel.replicateModal){
        viewContext.view.parametersPanel.replicateModal.selectedCount = selectedCount;
    }
};

const openReplicationModal = async (modal, replicateModal) => {
    replicateModal.selectedCount = 0;
    modal.show("replicate-params-modal", {});
    setTimeout(() => {
        replicateParametersGridConfiguration.advancedOptions.api.showNoRowsOverlay()
    }, 100)
}

const findDishesByFilterInput = async (replicateModal) => {
    const searchInput = replicateModal.filterText;
    const stringCount = [...searchInput].filter(char => char !== '%').length

    if(stringCount < 3) {
        Util.showNotification({ title: t('min_3_char') });
        return;
    };

    replicateParametersGridConfiguration.dataSource = async () => {
        return await PlatesService.getDishesFromSearch(searchInput);
    };
    replicateParametersGridConfiguration.reloadData();
    replicateModal.selectedCount = 0;
}

const applyReplicationData = async (modal, replicateModal) => {
    replicateModal.prepareLoading = true;

    const _exportFields = {
        "IDCOMPLEXIDADE": { label: t('complexity'), valueField: "IDCOMPLEXIDADE", optionsField: "complexityOptions" },
        "IDPREPREPARO": { label: t('preparation_pre'), valueField: "IDPREPREPARO", optionsField: "prePreparationOptions" },
        "IDCOR": { label: t('color'), valueField: "IDCOR", optionsField: "colorOptions" },
        "NRATRATIVIDADEPRATO": { label: t('attractiveness'), valueField: "NRATRATIVIDADEPRATO", optionsField: "attractivenesOptions" },
        "NRINGREDIENTEPRINC1": { label: t('ing_main_1'), valueField: "NRINGREDIENTEPRINC1", optionsField: "mainIngredientsOptions" },
        "NRINGREDIENTEPRINC2": { label: t('ing_main_2'), valueField: "NRINGREDIENTEPRINC2", optionsField: "mainIngredientsOptions" },
        "CDAPRERECE": { label: t('type_of_cut'), valueField: "CDAPRERECE", optionsField: "cutTypeOptions" },
        "NRFORMAPREPARO": { label: t('way_of_preparation'), valueField: "NRFORMAPREPARO", optionsField: "preparationMethodOptions" },
        "NRTIPOPROTEINA": { label: t('type_protein'), valueField: "NRTIPOPROTEINA", optionsField: "proteinTypeOptions" },
    };
    
    try {
        const selectedRows = replicateParametersGridConfiguration.advancedOptions.api.getSelectedRows();
        const error = selectedRows.length === 0 ? t('select_a_record_to_replicate') : null;

        if (error) {
            Util.showNotification({ title: error });
            return;
        }

        const rawIngredientListOptions = await mainIngretientsList();
        replicateModal.mainIngredientsOptions = rawIngredientListOptions.map(item => ({
            value: item.NRINGREDIENTEPRINC,
            label: item.NMINGREDIENTEPRINC
        }));

        const rawProteinTypeOptions = await PlatesService.getProteinType();
        replicateModal.proteinTypeOptions = rawProteinTypeOptions.map(item => ({
            value: item.NRTIPOPROTEINA,
            label: item.NMTIPOPROTEINA
        }));

        const rayCutTypeOptions = await PlatesService.getCutType();
        replicateModal.cutTypeOptions = rayCutTypeOptions.map(item => ({
            value: item.CDAPRERECE,
            label: item.TIPOCORTE
        }));

        const rawPreparationMethodOptions = await PlatesService.getPreparationMethod();
        replicateModal.preparationMethodOptions = rawPreparationMethodOptions.map(item => ({
            value: item.NRFORMAPREPARO,
            label: item.NMFORMAPREPARO
        }));

        const rawAttractivenessOptions = await PlatesService.getAttractiveness();
        replicateModal.attractivenesOptions = rawAttractivenessOptions.map(item => ({
            value: item.NRATRATIVIDADEPRATO,
            label: item.NMATRATIVIDADEPRATO
        }));

        const exportFrom = Object.keys(_exportFields)
            .filter(field => _exportFields.hasOwnProperty(field))
            .map(field => {
                const cfg = _exportFields[field];
                return {
                    fieldName: field,
                    label: cfg.label,
                    realValue: PlatesService.getValueFromRow(selectedRows, field, cfg.valueField),
                    valueField: cfg.valueField,
                    selected: false,
                    model: replicateModal[cfg.optionsField] || []
                };
            });

        replicateModal.replicateForm = [ ...exportFrom ];
        modal.show("replicate-modal-fields", {});
    } finally {
        replicateModal.prepareLoading = false;
    }
};

const closeReplicationModal = async (modal, replicateModal) => {
    const emptyDatasource = async () => {
        return []
    }

    replicateParametersGridConfiguration.dataSource = emptyDatasource;

    replicateModal.filterText = '';
    replicateModal.prepareLoading = false;
    replicateModal.selectedCount = 0;

    modal.hide('replicate-params-modal');
};

const confirmErrors = async (modal, replicateModal) => {
    modal.hide("replicate-modal-fields");
    modal.hide("replicate-modal-errors");
    await closeReplicationModal(modal, replicateModal);

    Util.showSuccessNotification({
        title: t('success'),
        text: t('replicated_successfully')
    });
};

const confirmReplication = async (modal, replicateModal) => {

    const ERR_NFI = t('err_nfi');
    const ERR_SCS = t('err_scs');
    const INF_CSV = t('err_csv');

    let hasEmptySelectedField = false;

    const { 
        units: { 
            allSelected: isAllUnitsSelected, selectedUnits
        },
        replicateForm
    } = replicateModal;


    try{
        const FILIAIS = isAllUnitsSelected ? 'T' : selectedUnits.join('_');
        if (FILIAIS === '') throw new Error(ERR_NFI);


        const selectedFields = replicateForm.filter(f => f.selected);
        if (selectedFields.length === 0) throw new Error(ERR_SCS);
        
        const PARAMETROS = selectedFields.map(f => f.fieldName).join('_');

        const fieldsPayload = replicateForm.reduce((acc, f) => {
            acc[f.fieldName] = f.selected ? f.value : null;
            if(f.selected && !f.value) {
                hasEmptySelectedField = true;
                acc[f.fieldName] = null;
            }
            return acc;
          }, {});


        const selectedRows = replicateParametersGridConfiguration.advancedOptions.api.getSelectedRows();
    
        const replicationForm = {
            FILIAIS,
            PARAMETROS,
            selectedRows,
            ...fieldsPayload
        };

        const callProcedure = async () => {
            replicateModal.replicateLoading = true;
            modal.show("replicate-modal-errors", {});
            replicateModal.errors = await PlatesService.replicationProcedureCaller(replicationForm);
            replicateModal.replicateLoading = false;

            if(replicateModal.errors.length === 0){
                await confirmErrors(modal, replicateModal);
            }
        }

        if(hasEmptySelectedField) {
            console.warn(INF_CSV);
            Util.showConfirmationDialog(modal, {
                onModalConfirm: async () => await callProcedure(),
            }, t('replication_empty_field_explanation'));
        }else{
            await callProcedure();
        }

    }catch(error){
        console.error(error.message);
        Util.showNotification({ title: error.message});
        replicateModal.replicateLoading = false;
    }
}

const importParameters = (modal, modalReactiveData) => {
    const keysData = _getSelectedParameterPlate();
    const sourceData = importPlatesGridConfiguration.advancedOptions.api.getSelectedRows()[0]
        || importPlatesGridConfiguration.getRowData()[0];
    if(sourceData){
        const CDFILIAL = _getCDFILIAL();
        const NRORG = Util.getLocalVar('userData').NRORG;
        
        const dataToSave = {
            ...sourceData, 
            CDAPRERECE: sourceData.CDAPRERECE || keysData.CDAPRERECE || null,
            CDPRATO: keysData.CDPRATO,
            CDFILAUXPRAT: keysData.CDFILAUXPRAT,
            NRATRATIVIDADEPRATO: keysData.NRATRATIVIDADEPRATO || null,
            PRATO_PARAMETRIZADO: keysData.PRATO_PARAMETRIZADO
        };
        modalReactiveData.importLoading = true;
        PlatesService.saveParametersGridData(dataToSave, CDFILIAL, NRORG).then(() => {
            const selectedNode = parametersGridConfiguration.advancedOptions.api.getSelectedNodes()[0];
            const dataToRefresh = {
                ...dataToSave, 
                NMPRATO: keysData.NMPRATO, 
                TIPOCORTE: sourceData.NMAPRERECE,
                PRATO_PARAMETRIZADO: "S",
                NMGRUPOPRATO: keysData.NMGRUPOPRATO,
                NRGRUPOPRATOSERV: keysData.NRGRUPOPRATOSERV
            };
            parametersGridConfiguration.updateRowNode({data: dataToRefresh, node: selectedNode});
            modal.hide('import-modal');
            modalReactiveData.importLoading = false;
        }).catch((e) => {
            Util.showErrorNotification({ title: t('error_when_importing_dish_parameters'), text: e.error });
            modalReactiveData.importLoading = false;
        });
    } else {
        Util.showNotification({ title: t('there_are_no_records_to_import')});
    }
};
const openImportModal = function(modal) {
    if(Object.keys(_getSelectedParameterPlate()).length){
        modal.show("import-modal", {});
    } else {
        Util.showNotification({ title: t('select_a_record_to_import')});
    }
};

const enterExportMode = function(parametersPanel, modal){
    const _exportFields = {
        "IDCOMPLEXIDADE": {label:t('complexity'), valueField: "IDCOMPLEXIDADE"},
        "IDPREPREPARO":{label: t('preparation_pre'), valueField: "IDPREPREPARO"},
        "IDCOR":{label: t('color'), valueField: "IDCOR"},
        "NMINGREDIENTEPRINC1" :{label: t('ing_main_1'), valueField: "NRINGREDIENTEPRINC1"},
        "NMINGREDIENTEPRINC2" :{label: t('ing_main_2'), valueField: "NRINGREDIENTEPRINC2"},
        "TIPOCORTE":{label: t('type_of_cut'), valueField: "CDAPRERECE"},
        "NMFORMAPREPARO":{label: t('way_of_preparation'), valueField: "NRFORMAPREPARO"},
        "NMATRATIVIDADEPRATO":{label: t('attractiveness'), valueField: "NRATRATIVIDADEPRATO"},
        "NMTIPOPROTEINA":{label: t('type_protein'), valueField: "NRTIPOPROTEINA"},
    };
    let error = !Object.keys(_getSelectedParameterPlate()).length && t('select_a_record_to_import') || null;
    error = _getSelectedParameterPlate().PRATO_PARAMETRIZADO === 'N' && t('the_selected_dish_has_not_yet_been_parameterized') || error;
    if(error === null){
        parametersPanel.exporting = true;
        parametersPanel.isExportingPlates = false;
        const selectedPlateParams = _getSelectedParameterPlate();
        const exportFrom = Object.keys(selectedPlateParams).
                filter(k => _exportFields.hasOwnProperty(k)).
                map(v => ({
                    fieldName: v, 
                    label: _exportFields[v].label, 
                    realValue: PlatesService.getValueFromRow(selectedPlateParams,v, _exportFields[v].valueField),
                    valueField: _exportFields[v].valueField,
                    value: selectedPlateParams[v],
                    selected: true}));
        parametersPanel.exportModal.exportFrom = {...exportFrom};   
        parametersPanel.exportModal.CDFILIAL = _getCDFILIAL();
        parametersGridConfiguration.advancedOptions.rowSelection = 'multiple';
        parametersGridConfiguration.advancedOptions.columnApi.setColumnVisible('checkboxColumn', true)
        parametersGridConfiguration.advancedOptions.api.deselectAll();
        modal.show("export-modal-fields", {});
    } else {
        Util.showNotification({ title: error});
        parametersPanel.exporting = false;   
    }
};

const enterSelectPlateMode = function(exportSection){
    switch (exportSection.name) {
        case 'parametersPanel':
            exportSection.exporting = true;
            exportSection.isExportingPlates = true;
            parametersGridConfiguration.advancedOptions.rowSelection = 'multiple';
            parametersGridConfiguration.advancedOptions.columnApi.setColumnVisible('checkboxColumn', true)
            parametersGridConfiguration.advancedOptions.api.deselectAll();
            break;
        case 'consumptionHistoryPanel':
            exportSection.exporting = true;
            consumptionHistoryGridConfiguration.advancedOptions.rowSelection = 'multiple';
            consumptionHistoryGridConfiguration.advancedOptions.columnApi.setColumnVisible('checkboxColumn', true)
            consumptionHistoryGridConfiguration.advancedOptions.api.deselectAll();
            break;
        default:
            return
    }
};

const enterExportPlateMode = function(exportPlatesSection, modal){
    let selectedRows = parametersGridConfiguration.advancedOptions.api.getSelectedRows();
    if(selectedRows.length === 0)return;
    const _exportFields = {
        "IDCOMPLEXIDADE": {label:t('complexity'), valueField: "IDCOMPLEXIDADE"},
        "IDPREPREPARO":{label: t('preparation_pre'), valueField: "IDPREPREPARO"},
        "IDCOR":{label: t('color'), valueField: "IDCOR"},
        "NMINGREDIENTEPRINC1" :{label: t('ing_main_1'), valueField: "NRINGREDIENTEPRINC1"},
        "NMINGREDIENTEPRINC2" :{label: t('ing_main_2'), valueField: "NRINGREDIENTEPRINC2"},
        "TIPOCORTE":{label: t('type_of_cut'), valueField: "CDAPRERECE"},
        "NMFORMAPREPARO":{label: t('way_of_preparation'), valueField: "NRFORMAPREPARO"},
        "NMATRATIVIDADEPRATO":{label: t('attractiveness'), valueField: "NRATRATIVIDADEPRATO"},
        "NMTIPOPROTEINA":{label: t('type_protein'), valueField: "NRTIPOPROTEINA"},
    };
    const exportFrom = Object.keys(_exportFields).map(key => ({
        fieldName: key,
        label: _exportFields[key].label,
        realValue: null,
        valueField: _exportFields[key].valueField,
        selected: true
    }));
    exportPlatesSection.exportPlates.exportModal.exportFrom = [...exportFrom];
    exportPlatesSection.exportPlates.exportModal.CDFILIAL = _getCDFILIAL();
    modal.show("export-plates-modal-fields", {});
};

const prepareDataHistoryConsumption = function(exportPlatesSection){
    let selectedRows = consumptionHistoryGridConfiguration.advancedOptions.api.getSelectedRows();
    if(selectedRows.length === 0) return false;

    const combined = selectedRows.map(item => {
        return `${item.CDFILAUXPRAT}${item.CDPRATO}_${item.VRPECONSCARD}`;
    });

    exportPlatesSection.exportModal.exportFrom = combined;
    exportPlatesSection.exportModal.CDFILIAL = _getCDFILIAL();
    return true;
};

const confirmExportPlates = function({exportPlates}) {
    let selectedRows = parametersGridConfiguration.advancedOptions.api.getSelectedRows();

    if(selectedRows.length){
        let {exportModal} = exportPlates;
        let exportFields = exportPlates.exportModal.exportFrom
        const selectedUnits = exportPlates.units.selectedUnits;
        const allSelected = exportPlates.units.allSelected;
        const mode = exportPlates.exportPlatesMode;

        const data = {
            selectedUnits,
            allSelected,
            mode
        }

        const onlySelected = Object.keys(exportFields).filter(ek => exportFields[ek].selected);
        const formatedExportFrom = onlySelected.map(f => ({[exportFields[f].fieldName] : exportFields[f].valueField}));

        Util.showNotification({ title: t('exporting_data_to',{PARAM:`${selectedRows.length}` })});

        exportModal.exportLoading = true;
        PlatesService.exportParametersToAnyFilial({source: formatedExportFrom, targets: selectedRows, initialCDFILIAL: exportModal.CDFILIAL, auxData: data}).
        then(() => {
            exportModal.exportLoading = false;
            Util.showSuccessNotification({ title: t('data_exported_successfully')});
        });
    } else {
        exportModal.exportLoading = false;
        Util.showNotification({ title: t('select_records_to_export')});
    }
};

const handleExport = function(parameters) {
    if (parameters.isExportingPlates){
        this.confirmExportPlates(parameters);
    } else {
        this.confirmExport(parameters);
    }
};

const exitExportMode = function(parametersPanel){
    parametersPanel.exporting = false;
    parametersPanel.exportModal.exportLoading = false;
    switch (parametersPanel.name) {
        case 'parametersPanel':
            parametersPanel.isExportingPlates = false;
            parametersGridConfiguration.advancedOptions.rowSelection = 'single';
            if(parametersGridConfiguration.advancedOptions.columnApi && parametersGridConfiguration.advancedOptions.api){
                parametersGridConfiguration.advancedOptions.columnApi.setColumnVisible('checkboxColumn', false);
                parametersGridConfiguration.advancedOptions.api.deselectAll();
            }
            break;
        case 'consumptionHistoryPanel':
            consumptionHistoryGridConfiguration.advancedOptions.rowSelection = 'single';
            if(consumptionHistoryGridConfiguration.advancedOptions.columnApi && consumptionHistoryGridConfiguration.advancedOptions.api){
                consumptionHistoryGridConfiguration.advancedOptions.columnApi.setColumnVisible('checkboxColumn', false);
                consumptionHistoryGridConfiguration.advancedOptions.api.deselectAll();
            }
            break;
        default:
            return
    }
};

const confirmExport = function({exportModal}){
    let selectedRows = parametersGridConfiguration.advancedOptions.api.getSelectedRows();
    if(selectedRows.length){
        let {exportFrom, CDFILIAL} = exportModal;

        const onlySelected = Object.keys(exportFrom).filter(ek => exportFrom[ek].selected);
        const formatedExportFrom = onlySelected.map(f => ({[exportFrom[f].valueField] : exportFrom[f].realValue}));
        
        let fullSource = onlySelected.map(f => ({[exportFrom[f].fieldName] : exportFrom[f].value}));
        fullSource = fullSource.concat(formatedExportFrom);
        
        const nodesToRefresh = parametersGridConfiguration.advancedOptions.api.getSelectedNodes();

        Util.showNotification({ title: t('exporting_data_to',{PARAM:`${selectedRows.length}` })});

        exportModal.exportLoading = true;
        PlatesService.exportParameters({source: formatedExportFrom, targets: selectedRows, fullSource, initialCDFILIAL: CDFILIAL}).
        then((changedData) => {
            if(nodesToRefresh.length === changedData.length){
                changedData.forEach((data, index) => {
                    parametersGridConfiguration.updateRowNode({data: data, node: nodesToRefresh[index]});
                });
            }
            exportModal.exportLoading = false;
            exitExportMode(arguments[0]);
            Util.showSuccessNotification({ title: t('data_exported_successfully')});
        });
    } else {
        exportModal.exportLoading = false;
        Util.showNotification({ title: t('select_records_to_export')});
    }
};

const deleteConsumptionHistory = function(panel){
    const {advancedOptions} = consumptionHistoryGridConfiguration;
    const selectedRows = advancedOptions.api.getSelectedRows();
    const selectedNodes = advancedOptions.api.getSelectedNodes();
    // return Promise.resolve();
    return PlatesService.deleteConsumptionHistoryGridData(selectedRows)
    .then((response) => {
        if(Array.isArray(response)){
            // remove row
            const removeIndex = selectedNodes[0].rowIndex;
            const newArr = consumptionHistoryGridConfiguration.getRowData();
            newArr.splice(removeIndex, 1)
            consumptionHistoryGridConfiguration.setRowData(newArr);
        } else if(response.dataset){
            const {data} = response.dataset;
            const newData = {...selectedRows[0], ...data[0]};
            delete newData.NRHISTCONSUMOPRATO;
            consumptionHistoryGridConfiguration.updateRowNode({data: newData, node: selectedNodes[0]});
        }
        panel.hasCheckedRows = false;
    })
    .catch(e => {
        Util.showErrorNotification({ title: t('error_deleting_consumption_percentage_history'), text: e.error })
    });
};

const saveRestrictionRuleDefaultErrorHandler = () => {
    Util.showErrorNotification({ title: t('unable_to_save_retry_restriction_rule')});
};

const saveRestrictionRule = function(name, rules, mode) {
    if(name){
        if(mode === 'add'){
            return PlatesService.insertRestrictionRule(name).then(newCode => {
                const newCodeParsed = parseInt(newCode[0]);
                rules.unshift({NRREGRARESTREPET: newCodeParsed, NMREGRARESTREPET: name});
                rules = Util.sortBy(rules, ['NRREGRARESTREPET']);
                return rules;
            }).catch(saveRestrictionRuleDefaultErrorHandler);
        } else if(mode === 'edit'){
            return PlatesService.updateRestrictionRule(sharedObject.selectedRestrictionRule, name).then(() => {
                const editingRule = rules.find(r => r.NRREGRARESTREPET === sharedObject.selectedRestrictionRule);
                editingRule.NMREGRARESTREPET = name;
                return rules;
            }).catch(saveRestrictionRuleDefaultErrorHandler);
        }
    } else {
        Util.showErrorNotification({ title: t('the_name_field_is_required')});
        return Promise.resolve();
    }
};

const updateConsumptionHistoryInterval = function(consumptionIntervalValue){
    return PlatesService.updateConsumptionHistoryInterval(
        {NRMESHISTCONS: consumptionIntervalValue}
    );
};

const submitFile = function(row, tableName){
    return PlatesService.submitFile(row, tableName);
};

const plateServiceInstance = {
    parametersGridConfiguration: parametersGridConfiguration,

    attractivenessGridConfiguration: attractivenessGridConfiguration,
    plateRecipeGrid,
    prapartionMethodGridConfiguration: prapartionMethodGridConfiguration,
    cutTypeGridConfiguration: cutTypeGridConfiguration,
    mainIngredientGridConfiguration: mainIngredientGridConfiguration,
    typeProteinGridConfiguration: typeProteinGridConfiguration,
    combinationGridConfiguration: combinationGridConfiguration,
    consumptionHistoryGridConfiguration,
    importPlatesGridConfiguration,
    replicateParametersGridConfiguration,
    restrictionRulesPlateTypeGridConfig,
    restrictionRulesIngredientGridConfig,

    refreshParametersGridData(e) {
        refreshParametersGridData(e);
    },

    deleteAttractiviness(panel) {
        deleteCheckedRows(this.attractivenessGridConfiguration, PlatesService.deleteAttractivenessGridData)
        .then(() => panel.hasCheckedRows = false)
        .catch(e => {
            Util.showErrorNotification({ title: t('error_deleting_attractiveness'), text: e.error })
        });
    },
    deletePreparationMethod(panel) {
        deleteCheckedRows(this.prapartionMethodGridConfiguration, PlatesService.deletePreparationMethodGridData)
        .then(() => panel.hasCheckedRows = false)
        .catch(e => {
            Util.showErrorNotification({ title: t('error_deleting_cooking_method'), text: e.error })
        });
    },
    deleteCutType(panel) {
        deleteCheckedRows(this.cutTypeGridConfiguration, PlatesService.deleteCutTypeGridData)
        .then(() => panel.hasCheckedRows = false)
        .catch(e => {
            Util.showErrorNotification({ title: t('error_deleting_cut_type'), text: e.error })
        });
    },
    deleteMainIngredient(panel) {
        deleteCheckedRows(this.mainIngredientGridConfiguration, PlatesService.deleteMainIngredientGridData)
        .then(() => panel.hasCheckedRows = false)
        .catch(e => {
            Util.showErrorNotification({ title: t('error_deleting_main_ingredient'), text: e.error })
        });
    },
    deleteTypeProtein(panel) {
        deleteCheckedRows(this.typeProteinGridConfiguration, PlatesService.deleteTypeProteinGridData)
        .then(() => panel.hasCheckedRows = false)
        .catch(e => {
            Util.showErrorNotification({ title: t('error_deleting_main_ingredient'), text: e.error })
        });
    },
    deleteCombination(panel) {
        deleteCheckedRows(this.combinationGridConfiguration, PlatesService.deleteCombinationGridData)
        .then(() => panel.hasCheckedRows = false)
        .catch(e => {
            Util.showErrorNotification({ title: t('error_deleting_combination'), text: e.error })
        });
    },
    deleteConsumptionHistory,

    refreshAttractivenessGridData(gridConfiguration) {
        PlatesService.getAttractivenessGridData().then(data => {
            gridConfiguration.setRowData(data);
        });
    },

    deleteAttractivenessGridData(gridData) {
        return PlatesProvider.deleteAttractivenessGridData(gridData);
    },

    getGeneratedExcellFromPython() {
        return PlatesProvider.getGeneratedExcellFromPython();
    },

    addNewAttractivinessRow() {
        addNewRowToGrid(this.attractivenessGridConfiguration);
    },

    getRestrictionRules(){
        return PlatesService.getRestrictionRules();
    },
    
    removePlateTypeRestrictionRule(){
        return restrictionRulesPlateTypeGridConfig.deleteCheckedRows(PlatesService.removePlateTypeRestrictionRule);
    },

    removeIngredientRestrictionRule(){
        return restrictionRulesIngredientGridConfig.deleteCheckedRows(PlatesService.removeIngredientRestrictionRule);
    },

    removeRestrictionRule(modal, {NRREGRARESTREPET, NMREGRARESTREPET}, onRemoveCompleted){
        if(NRREGRARESTREPET){
            Util.showConfirmationDialog(modal, 
                () => PlatesService.removeRestrictionRule(NRREGRARESTREPET).then(() => {
                    restrictionRulesPlateTypeGridConfig.setRowData([]);
                    restrictionRulesIngredientGridConfig.setRowData([]);
                    onRemoveCompleted();
                }), 
                t('are_you_sure_you_want_to_delete_the_rule', {PARAM: `${NMREGRARESTREPET}`}));
        } else {
            Util.showNotification({title: t('select_a_rule_to_delete')})
        }
    },

    saveRestrictionRule,
    insertNewCombinationRow,
    reloadCombination,
    reloadAttractiveness,
    updateConsumptionHistoryInterval,
    importParameters,
    openReplicationModal,
    findDishesByFilterInput,
    applyReplicationData,
    closeReplicationModal,
    confirmReplication,
    confirmErrors,
    mainIngretientsList,
    openImportModal,
    focusCell,
    addNewRowToGrid,
    enterExportMode,
    enterExportPlateMode,
    enterSelectPlateMode,
    prepareDataHistoryConsumption,
    confirmExportPlates,
    handleExport,
    exitExportMode,
    confirmExport,
    changeConsumptionHistoryDataSource,
    sharedObject,
    init() {
        CDPICTPRAT = Util.getFilterInSession().CDPICTPRAT;
    },
    submitFile,
}

export default plateServiceInstance;
